export default __webpack_public_path__ + "static/media/about.c6ff8c1f.svg";